// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import useScrollContext from "@store/Framework/Common/Hooks/useScrollContext";
import { isHeaderFixedOptionSelector } from "@store/Framework/Store/Bunzl/Components/Header/HeaderSelectors";
import useDispatchFixedHeader from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useDispatchFixedHeader";
import useHeaderHeight from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useHeaderHeight";

export default () => {
    const { scroll } = useScrollContext();
    const { headerHeight } = useHeaderHeight();
    const isHeaderFixed = useAppSelector(state => isHeaderFixedOptionSelector(state));
    const dispatchFixedHeader = useDispatchFixedHeader();

    return {
        isHeaderFixed, // Store Custom Code
        setIsHeaderFixed: (isFixed: boolean) => {
            dispatchFixedHeader(isFixed);
        },
    };
};
